"use client"

import { useState } from "react"
import { Menu, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import logo from "@/public/images/logo.webp"
import Image from "next/image"

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center py-[8px]">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="flex items-center space-x-2">
                <a href="/" aria-label="home page of capfinserve">
                  <Image
                    className="w-[150px]"
                    src={logo}
                    alt="Caps FinServ - Financial Planning Services in India"
                    priority
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Desktop Contact Info */}
          <div className="flex items-center space-x-6 bg-[#F3F6FA] py-[8px] px-[12px] rounded-[8px]">
            <div className="flex items-center md:space-x-4 space-x-2 text-sm">
              <span className="text-[#0E172A] underline md:text-[14px] text-[12px] font-medium hover:text-caps-blue-dark transition-colors cursor-pointer">
                Contact Us
              </span>
              <a href="tel:+919940121778" target="_blank" className="text-[#1156FB] md:text-[14px] text-[12px] font-medium hover:text-caps-blue-dark transition-colors cursor-pointer">
                +919940121778
              </a>
              <a href="mailto:info@capsfinserv.com" target="_blank" className="text-[#1156FB] md:text-[14px] text-[12px] font-medium hover:text-caps-blue-dark transition-colors cursor-pointer">
                info@capsfinserv.com
              </a>
            </div>
          </div>

        </div>

      </div>
    </nav>
  )
}
